import React, { FunctionComponent, useContext } from 'react';
import classNames from 'classnames';
import styles from './styles.module.scss';
import { UserAgentContext } from 'features/user-agent/userAgent';

interface LogoImageProps {
  children: React.ReactNode;
  size?: string;
}

export const LogoImage: FunctionComponent<LogoImageProps> = (props) => {
  const { children, size } = props;
  const { isEmbed } = useContext(UserAgentContext);

  const onClick = () => {
    if (isEmbed) {
      window.open(window.location.href, '_blank');
    }
  };

  return (
    <div
      className={classNames(
        styles['logo-image'],
        { [styles['logo-image--medium']]: size === 'medium' },
        { [styles['logo-image--small']]: size === 'small' },
        { [styles['logo-image--mini']]: size === 'mini' },
        { [styles['logo-image--tiny']]: size === 'tiny' }
      )}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
